import { Box, Typography } from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import Text from "../../../shared/components/Text";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { ENV_APP_URL } from "../../../../config/envVars";
import { QRCodeSVG } from "qrcode.react";
import { LoanStatus } from "@nemuru-eng/js-api-client";
import { assetTypes } from "../../../shared/config";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import { useTheme } from "@material-ui/styles";
import { useMediaQuery } from "@material-ui/core";

export const ValidationLink = () => {
  const {
    state: { language },
  } = useContext(ConfigContext);

  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down("xs"));
  const {
    state: { loan },
    dispatch,
  } = useContext(ProcessContext);

  const downloadAppLogoHeight = isMobile ? 36 : 40;

  const showValidationLink =
    loan &&
    loan.asset_reference[0].type === assetTypes.CARD &&
    loan.status === LoanStatus.STATUS_CONTRACT_SIGNED;

  useEffect(() => {
    if (!showValidationLink) {
      onNext();
    }
  }, []);

  const onNext = () => {
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });
  };

  const qrCodeUrl = `${ENV_APP_URL}loan/${loan.id}/validation`;

  if (!showValidationLink) {
    return null;
  }

  return (
    <>
      <Box
        pb={2}
        display="flex"
        flexDirection={"column"}
        alignItems="center"
        gridGap={32}
      >
        <Typography variant="body2" style={{ textAlign: "center" }}>
          <Text tId="VALIDATION_LINK_QR_CODE_DESCRIPTION_1" />
        </Typography>
        <QRCodeSVG value={qrCodeUrl} size={"80%"} className="max-w-full" />
        <Typography variant="body2" style={{ textAlign: "center" }}>
          <Text tId="VALIDATION_LINK_QR_CODE_DESCRIPTION_2" />
        </Typography>
      </Box>
      <Box
        justifyContent={"center"}
        display="flex"
        flexDirection="row"
        gridGap={8}
      >
        <a
          href="https://apps.apple.com/es/app/inone-financia-tus-compras/id6502599330"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={`https://cdn.nemuru.com/assets/logos/download_on_the_app_store_${language}.svg`}
            alt="download_from_app_store"
            height={downloadAppLogoHeight}
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.caixabankpc.nowpay"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={`https://cdn.nemuru.com/assets/logos/get_it_on_google_play_${language}.svg`}
            alt="download_from_google_play"
            height={downloadAppLogoHeight}
          />
        </a>
      </Box>
    </>
  );
};
